import { render, staticRenderFns } from "./PhoneOne.vue?vue&type=template&id=ada0fcde&scoped=true&"
import script from "./PhoneOne.vue?vue&type=script&lang=js&"
export * from "./PhoneOne.vue?vue&type=script&lang=js&"
import style0 from "./PhoneOne.vue?vue&type=style&index=0&id=ada0fcde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada0fcde",
  null
  
)

export default component.exports